import React from "react";
import SearchOffOutlinedIcon from "@mui/icons-material/SearchOffOutlined";
import { useNavigate } from "react-router-dom";
import StatusView from "../../atoms/StatusView/StatusView";

const PaginaNaoEncontrada: React.FC = () => {
  const navigate = useNavigate();

  const handleReturn = () => {
    const lastVisited = localStorage.getItem("lastVisited");

    if (lastVisited) {
      navigate(lastVisited);
      return;
    }

    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate("/");
  };

  return (
    <StatusView
      code="404"
      title="Pagina nao encontrada"
      description="A pagina que voce esta procurando nao existe ou nao esta mais disponivel."
      actionLabel="Voltar"
      onAction={handleReturn}
      icon={<SearchOffOutlinedIcon fontSize="large" />}
    />
  );
};

export default PaginaNaoEncontrada;
